import React from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import OverrideControls from './OverrideControls';
import UnauthorizedUserAccessView from './UnauthUserAccessView';
import { ClassLevelOverrideOptions, UnauthUserAccess } from '../../../types/adminConfig';
import AdminSettingsContainer from '../AdminSettingsContainer';
import { StyledFormGroupContainer } from '../styles';

const UnauthorizedUserAccessSetting = () => {
    const { adminSettings, setAdminSettings } = useContainer(AdminSettingsContainer);
    const { authSettings, featureSettings } = adminSettings;
    const { unauthUserAccess: unauthUserAccessOverride = ClassLevelOverrideOptions.NoOne } = featureSettings.overrides;

    const { t } = useTranslation('admin_settings');

    const setSetting = (settings: UnauthUserAccess) => {
        featureSettings.options.unauthUserAccess = settings;
        featureSettings.options.unauthUserText = '';
        setAdminSettings({ ...adminSettings });
    };

    const setText = (text: string) => {
        featureSettings.options.unauthUserText = text;
        setAdminSettings({ ...adminSettings });
    };

    const handleUpdateOverrides = (event: React.ChangeEvent<HTMLInputElement>) => {
        featureSettings.overrides[event.target.name] = event.target.value;
        setAdminSettings({ ...adminSettings });
    };

    return (
        <>
            <UnauthorizedUserAccessView
                setting={featureSettings.options.unauthUserAccess ?? UnauthUserAccess.Allow}
                setSetting={setSetting}
                text={authSettings.unauthUserText}
                setText={setText}
            />

            <StyledFormGroupContainer>
                <OverrideControls
                    overrideName="unauthUserAccess"
                    overrideValue={unauthUserAccessOverride}
                    handleUpdateOverrides={handleUpdateOverrides}
                    labelText={t('configuration.auth-override')}
                    tooltipText={t('configuration.no-one-auth-access-tooltip')}
                />
            </StyledFormGroupContainer>
        </>
    );
};

export default UnauthorizedUserAccessSetting;
